import { render, staticRenderFns } from "./DealerInfo.vue?vue&type=template&id=22201eb5&scoped=true&"
import script from "./DealerInfo.vue?vue&type=script&lang=js&"
export * from "./DealerInfo.vue?vue&type=script&lang=js&"
import style0 from "./DealerInfo.vue?vue&type=style&index=0&id=22201eb5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22201eb5",
  null
  
)

export default component.exports